import React, { useContext, useState } from "react";
import { Request } from "../../api/support/Support.api";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import { AuthContext } from "../../context/auth/AuthContext";
import Success from "../../components/Success";
import {useTranslation} from "react-i18next";

const CreateSupportContainer = ({ children, handleClose }) => {
  const initialValues = {
    first_name: "",
    last_name: "",
    email: "",
    username: "",
    password: "",
    confirm_password: "",
    telephone_number: "",
    cellular_number: "",
    fax_number: "",
    street: "",
    city: "",
    cap: "",
    district: "",
    country: "",
  };

  const { t } = useTranslation();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);
  const { token } = useContext(AuthContext);

  const onSubmit = (values, actions) => {
    setError(null);
    setLoading(true);
    Request.createSupport(token.access, values)
      .then((data) => onSuccess(data, actions))
      .catch((error) => onFailure(error, actions));
  };

  const onSuccess = (data, actions) => {
    actions.setSubmitting(false);
    setLoading(false);
    setSuccess(true);
  };

  const onClose = () => {
    setSuccess(null)
    handleClose()
  }

  const onFailure = (error, actions) => {
    setError(error);
    setLoading(false);
    actions.setSubmitting(false);
  };

  return (
    <>
      {error ? <Error message={error} onClose={() => setError(null)} /> : null}
      {success ? <Success message={t("create_support.success")} onClose={onClose} /> : null}
      {loading ? <Loading /> : null}
      {children({ onSubmit, initialValues })}
    </>
  );
};

export default CreateSupportContainer;
